import { render, staticRenderFns } from "./airConfig.vue?vue&type=template&id=01887ed4&"
import script from "./airConfig.vue?vue&type=script&lang=js&"
export * from "./airConfig.vue?vue&type=script&lang=js&"
import style0 from "./airConfig.vue?vue&type=style&index=0&id=01887ed4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports